module.exports = __webpack_public_path__ + "static/img/azsk.41109ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/azsk.png
// module id = pIms
// module chunks = 0